import React from 'react';
import {useLocale} from '../Localization/LocaleContext';

const LocaleSelector = ({compact = false, textColor, borderColor}) => {
  const {locale, setLocale, supportedLocales, translate} = useLocale();

  return (
    <label
      className={`inline-flex items-center ${compact ? 'gap-1 rounded-md px-1.5 py-1 text-[10px]' : 'gap-2 rounded-lg px-2.5 py-1.5 text-xs'} border border-white/20 font-medium`}
      style={{color: textColor || 'var(--sidebar-text)', borderColor: borderColor || 'rgba(255,255,255,0.2)'}}>
      {!compact && <span aria-hidden="true">◎</span>}
      <span className="sr-only">{translate("common.language")}</span>
      <select
        aria-label={translate("common.language")}
        value={locale}
        onChange={event => setLocale(event.target.value)}
        className={`cursor-pointer bg-transparent text-inherit outline-none ${compact ? 'max-w-[76px]' : 'max-w-[112px]'}`}
        style={{color: 'inherit', fontSize: compact ? 11 : undefined, lineHeight: compact ? '14px' : undefined}}>
        {supportedLocales.map(item => (
          <option key={item.code} value={item.code} style={{color: '#17243a'}}>
            {item.nativeLabel}
          </option>
        ))}
      </select>
    </label>
  );
};

export default LocaleSelector;
